<template>
  <div>
    <el-card
      class="box-card primary"
      :class="{ notRadiusLeft: type == 'comment' }"
      shadow="never"
    >
      <div v-if="type == 'post'" slot="header" class="text-left">
        <span class="pd-x-3">หัวข้อกระทู้: {{ title }}</span>
      </div>
      <div class="text item pd-x-3">
        <div class="flex-display ai-start js-between border-b pd-b-3">
          <div class="flex-display ai-center">
            <div class="box-image">
              <avatar
                :rounded="false"
                :username="createName"
                :src="`${urlImage}${createBy}/${createProfileImg}`"
                :size="type == 'post' ? 60 : 40"
              >
              </avatar>
            </div>
            <div class="text-left pd-l-5">
              <p
                class="mg-y-5"
                :class="type == 'post' ? 'text-font-16' : 'text-font-14'"
              >
                {{ createName }}
              </p>
              <p
                class="mg-y-5 color-gray"
                :class="type == 'post' ? 'text-font-12' : 'text-font-10'"
              >
                <i class="fas fa-clock"></i> {{ createAt | dateTimeTh }}
              </p>
            </div>
          </div>
          <div v-if="user && (user.role == 60 || user.role == 80) && type == 'comment'" class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="showEditor = true"
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-pen"></i>
              </div>
            </div>
            <div class="box-action">
              <el-popconfirm
                confirmButtonText="ใช่"
                cancelButtonText="ไม่"
                icon="el-icon-info"
                iconColor="red"
                title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                @onConfirm="delComment"
              >
                <div
                  slot="reference"
                  class="circle-action color-bg-danger-lighter"
                >
                  <i class="fas fa-trash-alt"></i>
                </div>
              </el-popconfirm>
            </div>
          </div>
        </div>
        <div v-if="showEditor == true" class="pd-t-4 width-100">
          <el-form label-position="top" :model="form" :rules="rules" ref="form">
            <el-form-item  label="" prop="comment">
              <yimo-vue-editor
                v-model="form.comment"
                @input="checkValid('comment')"
              ></yimo-vue-editor>
            </el-form-item>
            <el-form-item label="" class="text-right">
              <el-button @click="showEditor = false" type="text"
                ><span class="color-gray">ยกเลิก</span></el-button
              >
              <el-button
                @click="updateComment"
                type="primary"
                ><span class="pd-x-4">บันทึก</span></el-button
              >
            </el-form-item>
          </el-form>
          <p class="text-font-12 text-right">
            ตัวอักษรอย่างน้อย {{ form.comment.length }}/20 ตัวอักษร
          </p>
        </div>
         <div v-else  class="text-left pd-t-5">
          <span v-html="form.comment"></span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    Avatar
  },
  props: {
    discussionId: {
      type: String,
      default() {
        return "";
      },
    },
    replyId: {
      type: String,
      default() {
        return "";
      },
    },
    type: {
      type: String,
      default() {
        return "post";
      },
    },
    title: {
      type: String,
      default() {
        return "";
      },
    },
    description: {
      type: String,
      default() {
        return "";
      },
    },
    createAt: {
      type: Date,
      default() {
        return "";
      },
    },
    createBy: {
      type: String,
      default() {
        return "";
      },
    },
    createName: {
      type: String,
      default() {
        return "";
      },
    },
    createProfileImg: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    user(){
      return this.$store.state.user
    },
    token() {
      return this.$store.state.token;
    },
  },
  watch: {
    description(){
      this.setComment()
    }
  },
  data() {
    var validateRangeComment = (rule, value, callback) => {
      if (value.length < 20) {
        callback(new Error("กรุณากรอกความคิดเห็นอย่างน้อย 20 ตัวอักษร"));
      } else {
        callback();
      }
    };
    return {
      form: {
        comment: "",
      },
      rules: {
        comment: [
          {
            required: true,
            message: "กรุณากรอกความคิดเห็น",
            trigger: "blur",
          },
          { validator: validateRangeComment, trigger: "blur" },
        ],
      },
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
      showEditor:false
    };
  },
  mounted() {
    this.setComment()
  },
  methods: {
    setComment(){
      this.form ={
         comment:this.description
      }
    },
    delComment() {
      let obj = {
        disscussionId:this.discussionId,
        replyId:this.replyId
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/reply`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchDiscussionId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delDescussionForum error", e);
        })
    },
    updateComment() {
      this.$refs["form"].validate((valid) => {
        if (valid) {

          let obj = {
            disscussionId:this.discussionId,
            replyId:this.replyId,
            replyText:this.form.comment
          };

          HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          HTTP.post(`update/reply`, obj)
            .then((res) => {
              if (res.data.success) {
                this.showEditor = false
                this.$emit("fetchDiscussionId");
                
              } else {
                this.alertFailError();
              }
            })
            .catch((e) => {
              this.alertCatchError(e);
              console.log("updateComment error", e);
            })
          }
      })
    },
    checkValid(field) {
      if (this.$options.filters.striphtml(this.form.comment) == "") {
        this.form.comment = "";
      }
      this.$refs["form"].validateField(field);
    },
  },
};
</script>

<style scoped>
.notRadiusLeft {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
